var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          ref: "updateRoleForm",
          attrs: { novalidate: "", disabled: _vm.loading },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "mb-10" },
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-roles",
                              title: _vm.getTitle
                                ? `${_vm.getTitle} роль`
                                : `Создать роль`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tabs",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        _vm._l(_vm.tabs, function (tab) {
                          return _c(
                            "v-tab",
                            {
                              key: tab.value,
                              attrs: {
                                disabled: tab.isDisabled || _vm.disabled,
                              },
                            },
                            [_vm._v(" " + _vm._s(tab.title) + " ")]
                          )
                        }),
                        1
                      ),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "PageContent",
                                    { attrs: { height: "80" } },
                                    [
                                      _c(
                                        "v-container",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [_vm._v("Имя *")]),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      outlined: "",
                                                      autofocus: "",
                                                      id: "name",
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .name,
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                    },
                                                    model: {
                                                      value: _vm.fields.name,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "name",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "fields.name",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [_vm._v("Key *")]),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      outlined: "",
                                                      autofocus: "",
                                                      id: "key",
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .key,
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                    },
                                                    model: {
                                                      value: _vm.fields.key,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "key",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "fields.key",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Описание"),
                                                  ]),
                                                  _c("v-textarea", {
                                                    attrs: {
                                                      outlined: "",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields.description,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "description",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.description",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "PageContent",
                                    [
                                      _c(
                                        "v-list",
                                        _vm._l(
                                          _vm.permissionGroups,
                                          function (permissionGroup) {
                                            return _c(
                                              "v-list-group",
                                              {
                                                key: permissionGroup.id,
                                                attrs: { "no-action": "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item-content",
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        permissionGroup.name
                                                                      ) +
                                                                      " (" +
                                                                      _vm._s(
                                                                        _vm.chosenPermissionAmount(
                                                                          permissionGroup.permissions
                                                                        )
                                                                      ) +
                                                                      ") "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    attrs: {
                                                      dense: "",
                                                      disabled:
                                                        _vm.data.isProtected ||
                                                        _vm.disabled,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateGroupPermissionHandler(
                                                          permissionGroup.permissions
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        dense: "",
                                                        loading: _vm.loading,
                                                        disabled:
                                                          _vm.disabled ||
                                                          _vm.data.isProtected,
                                                        "input-value":
                                                          _vm.isAllPermissionsGroupChosen(
                                                            permissionGroup,
                                                            _vm.permissionsIdList
                                                          ),
                                                        indeterminate:
                                                          !_vm.isAllPermissionsGroupChosen(
                                                            permissionGroup,
                                                            _vm.permissionsIdList
                                                          ) &&
                                                          permissionGroup.permissions.some(
                                                            (p) =>
                                                              _vm.permissionsIdList.includes(
                                                                p.id
                                                              )
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.updateGroupPermissionHandler(
                                                            permissionGroup.permissions
                                                          )
                                                        },
                                                      },
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        },
                                                      },
                                                    }),
                                                    _c("span", [
                                                      _vm._v(" Все "),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _c("v-divider"),
                                                _vm._l(
                                                  permissionGroup.permissions,
                                                  function (permission) {
                                                    return _c(
                                                      "v-list-item",
                                                      {
                                                        key: permission.id,
                                                        attrs: {
                                                          dense: "",
                                                          loading: _vm.loading,
                                                          disabled:
                                                            _vm.disabled ||
                                                            _vm.data
                                                              .isProtected,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.updatePermissionHandler(
                                                              permission.id,
                                                              _vm.permissionsIdList.includes(
                                                                permission.id
                                                              )
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-content",
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              [
                                                                _c(
                                                                  "v-row",
                                                                  {
                                                                    attrs: {
                                                                      "no-gutters":
                                                                        "",
                                                                      align:
                                                                        "center",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          "hide-details":
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          loading:
                                                                            _vm.loading,
                                                                          disabled:
                                                                            _vm.disabled ||
                                                                            _vm
                                                                              .data
                                                                              .isProtected,
                                                                          "input-value":
                                                                            _vm.permissionsIdList.includes(
                                                                              permission.id
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              _vm.updatePermissionHandler(
                                                                                permission.id,
                                                                                _vm.permissionsIdList.includes(
                                                                                  permission.id
                                                                                )
                                                                              )
                                                                            },
                                                                        },
                                                                        nativeOn:
                                                                          {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                              },
                                                                          },
                                                                      }
                                                                    ),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            permission.name
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      "is-new": !_vm.data.id,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "published-at": _vm.data.publishedAt,
                      author: _vm.data.author ? _vm.data.author.name : "",
                      "is-loading": _vm.loading,
                      "is-protected": _vm.data.isProtected,
                      "is-submit-disabled":
                        _vm.activeTab ===
                          _vm.tabs.findIndex(
                            (tab) => tab.value === "permissions"
                          ) || _vm.disabled,
                      "entity-id": _vm.data.id,
                      "entity-type": "role",
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-role")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-roles" })
                      },
                      submit: _vm.submit,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }